'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'link-horizontal';
var width = 576;
var height = 512;
var aliases = ["chain-horizontal"];
var unicode = 'e1cb';
var svgPathData = ['', 'M304 304c70.7 0 128-57.3 128-128S374.7 48 304 48L144 48C73.3 48 16 105.3 16 176 16 225.6 44.3 268.7 85.6 289.9 84.3 295.2 83.2 300.7 82.3 306.2 33.6 283 0 233.5 0 176 0 96.5 64.5 32 144 32l160 0c79.5 0 144 64.5 144 144S383.5 320 304 320l-72 0c-4.4 0-8-3.6-8-8s3.6-8 8-8l72 0zm256 32c0-49.6-28.3-92.7-69.6-113.9 1.3-5.3 2.4-10.7 3.3-16.2 48.7 23.1 82.3 72.7 82.3 130.2 0 79.5-64.5 144-144 144l-160 0c-79.5 0-144-64.5-144-144s64.5-144 144-144l72 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-72 0c-70.7 0-128 57.3-128 128s57.3 128 128 128l160 0c70.7 0 128-57.3 128-128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLinkHorizontal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;